import type { ChildrenProps, ClassNameProps } from "../types";

/** Props Interface */
interface DataGridLabelProps extends ClassNameProps, ChildrenProps {}

export function DataGridLabel({ children, className }: DataGridLabelProps) {
	/** Render */
	return (
		<p
			data-label
			className={className}
		>
			{children}
		</p>
	);
}
